import { render, staticRenderFns } from "./TrasegadoList.vue?vue&type=template&id=6815f270&scoped=true&"
import script from "./TrasegadoList.vue?vue&type=script&lang=js&"
export * from "./TrasegadoList.vue?vue&type=script&lang=js&"
import style0 from "./TrasegadoList.vue?vue&type=style&index=0&id=6815f270&lang=scss&scoped=true&"
import style1 from "./TrasegadoList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815f270",
  null
  
)

export default component.exports